import { FC, PropsWithChildren } from "react";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "theme";
import { GlobalStyle } from "theme/GlobalStyles";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "setup/apollo";
import { UserContextProvider } from "contexts/UserContext";
import { VenueContextProvider } from "contexts/VenueContext";
import { PaymentTerminalContextProvider } from "contexts/PaymentTerminalContext";
import BfCacheClearfix from "components/atoms/BfCacheClearfix";

import IntlProvider from "./IntlProvider";

const AppProvider: FC<PropsWithChildren> = ({ children }) => (
  <ApolloProvider client={apolloClient}>
    <BfCacheClearfix />
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyle />
      <IntlProvider>
        <VenueContextProvider>
          <PaymentTerminalContextProvider>
            <UserContextProvider>
              {({ isInitializing }) => (isInitializing ? null : children)}
            </UserContextProvider>
          </PaymentTerminalContextProvider>
        </VenueContextProvider>
      </IntlProvider>
    </ThemeProvider>
  </ApolloProvider>
);

export default AppProvider;
